'use client';

import { useAddressStore } from '@/entities/address/model/use-address-store';
import Mobile from './mobile';

const Map = () => {
  const map = useAddressStore((state) => state.map);
  const closeMap = useAddressStore((state) => state.closeMap);

  if (!map) {
    return null;
  }

  const commonProps = {
    open: map,
    onClose: () => closeMap(),
  };

  return <Mobile {...commonProps} />;
};

export default Map;
